import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { User, CreateUser, Employees } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/api/employees`;
  
  getUsers(): Observable<User[]> {
    return this.http.get<Employees>(this.apiUrl).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[UsersService] GET request failed', error);
        return throwError(() => error);
      })
    );
  }
  
  updateUser(user: User): Observable<User> {
    return this.http.put<User>(`${this.apiUrl}/${user.id}`, user).pipe(
      catchError((error) => {
        console.error('[UsersService] PUT request failed', error);
        return throwError(() => error);
      })
    );
  }
  
  deleteUser(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/${id}`).pipe(
      catchError((error) => {
        console.error('[UsersService] DELETE request failed', error);
        return throwError(() => error);
      })
    );
  }
  
  createUser(user: CreateUser): Observable<User> {
    return this.http.post<User>(this.apiUrl, user).pipe(
      catchError((error) => {
        console.error('[UsersService] POST request failed', error);
        return throwError(() => error);
      })
    );
  }
}
